module.exports = __webpack_public_path__ + "static/media/ochaco-uraraka.e0269288.png";